export default __webpack_public_path__ + "vision-overview-header-image-960-dd680b5380f03af6fb0bac145e6d7ea8.webp";